/**
 * Perfil con partner DreamVinyl aprobado (badge de confianza en marketplace).
 */
export function isDreamvinylVerifiedPartner({
  isVerified,
  isStore,
  partnerRoleKeys,
  sellerIsVerified,
  sellerIsStore,
  sellerPartnerRoleKeys,
} = {}) {
  const verified = isVerified ?? sellerIsVerified ?? false;
  const store = isStore ?? sellerIsStore ?? false;
  const roles = partnerRoleKeys ?? sellerPartnerRoleKeys;
  if (verified || store) return true;
  return Array.isArray(roles) && roles.length > 0;
}
